module.exports = __webpack_public_path__ + "media/images/flags/gu-131e5a11ba6b94a65c22bcb80e6b8809.svg";